import React from "react";
import { Helmet } from "react-helmet-async";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import WebsiteLayout from "layouts/WebsiteLayout";

import { routes } from "routes/routes";

const PrivacyPolicy: React.FC = () => {
  const appLink = (
    <Link target="_blank" underline="none" href="https://ibanoplata.com/">
      https://ibanoplata.com
    </Link>
  );

  const appLinkUppercase = (
    <Link target="_blank" underline="none" href="https://ibanoplata.com/">
      HTTPS://IBANOPLATA.COM
    </Link>
  );

  return (
    <WebsiteLayout>
      <Helmet>
        <link
          rel="canonical"
          href={`${window.location.origin}${routes.publicOffer}`}
        />
      </Helmet>
      <Typography variant="h2" mt={4}>
        ПРАВИЛА КОРИСТУВАННЯ
      </Typography>
      <Typography variant="h3" mt={4} fontWeight="bold">
        сервісом на веб-сайті {appLink} (ПУБЛІЧНА ОФЕРТА)
      </Typography>
      <Typography mt={1}>
        Приймаючи публічну оферту, Ви (як Користувач) погоджуєтесь зі всіма
        викладеними нижче умовами і підтверджуєте, що Вам зрозумілі всі її
        положення та укладаєте на цих умовах договір про надання послуг з ТзОВ
        &#34;ФОПкаса&quot;.
      </Typography>

      <Typography mt={1} mb={1} variant="h4" fontWeight="bold">
        ДОГОВІР ПУБЛІЧНОЇ ОФЕРТИ ПРО НАДАННЯ ПОСЛУГ ЩОДО КОРИСТУВАННЯ сервісом,
        який міститься на веб-сайті {appLink}
      </Typography>
      <Typography mb={1}>
        Даний договір публічної оферти укладено між товариством з обмеженою
        відповідальністю «ФОПкаса» (далі - Виконавець) і користувачами веб-сайту
        {appLink} (далі – Користувач), разом у тексті – Сторони, окремо Сторона,
        про надання послуг (далі – Договір) на визначених у ньому умовах
        користування сервісом.
      </Typography>
      <Typography mb={1}>
        Ця публічна оферта містить ознаки публічного договору та договору
        приєднання – умови викладені в стандартній та незмінній для усіх
        Користувачів формі. Використовуючи веб-сайт {appLink}, Користувачі
        підтверджують, що ознайомлені та погоджуються з усіма положеннями цієї
        публічної оферти.
      </Typography>
      <Typography mb={1}>
        Користувачі не можуть пропонувати свої умови до цієї публічної оферти.
      </Typography>
      <Typography mb={1}>
        До відносин Користувачів і Правовласника застосовуються положення ст.
        633 Цивільного кодексу України (щодо публічного договору) ст. 634
        Цивільного кодексу України (щодо договору приєднання), а також інші
        законодавчі положення, передбачені чинним законодавством України, які
        врегульовують відносини сторін.
      </Typography>
      <Typography mb={1}>
        Приєднанням до цих Правил вважатимуться конклюдентні дії: щодо
        використання сервісу на веб-сайті {appLink} та/або вчинення інших дій,
        передбачених цими правилами (публічною офертою), які трактуються як
        приєднання до цієї публічної оферти. У разі незгоди з умовами цього
        Договору укладення договору приєднання не є можливим.
      </Typography>
      <Typography mb={1}>
        Приєднання до цих Правил засвідчує повне визнання Користувачем Умов
        користування сервісом на веб-сайті {appLink}. Користувачі не можуть
        пропонувати свої умови до цих Правил.
      </Typography>
      <Typography mb={1}>
        Правила (публічна оферта) адресовані невизначеному колу осіб, які
        користуються веб-сайтом {appLink}.
      </Typography>
      <Typography mb={1}>
        Особою, що володіє виключними майновими правами інтелектуальної
        власності на комерційне позначення IBAN OPLATA, є Правовласник, який має
        виключні права на їх використання (у тому числі право на реєстрацію цих
        позначень в якості торговельної марки). Користувачі мають право
        використовувати вказане комерційне позначення лише за умови отримання
        окремого письмового дозволу Правовласника.
      </Typography>
      <Typography mb={1}>
        ВИ ЯК КОРИСТУВАЧ ПОГОДЖУЄТЕСЯ, ЩО КОРИСТУВАННЯ ВЕБ-САЙТОМ{" "}
        {appLinkUppercase} ЗАСВІДЧУЄ ТОЙ ФАКТ, ЩО ВИ ПРОЧИТАЛИ ЦІ ПРАВИЛА,
        ЗРОЗУМІЛИ ЇХ УМОВИ Й ПОЛОЖЕННЯ ТА ЗГОДНІ ЇХ ДОТРИМУВАТИСЯ.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        УМОВИ КОРИСТУВАННЯ ВЕБ-САЙТОМ
      </Typography>
      <Typography mb={1}>
        Ці умови користування розроблено Правовласником для Користувачів з метою
        надання Користувачеві послуг на веб-сайті {appLink}.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ОСНОВНІ ПОНЯТТЯ
      </Typography>
      <Typography mb={1}>
        Веб-сайт - {appLink}, який працює як сервіс для здійснення платежів
        (далі сервіс, сервіс на веб-сайті {appLink}).
      </Typography>
      <Typography mb={1}>
        IBAN рахунок (International Bank Account Number) — міжнародний номер
        банківського рахунку, застосування якого є обов’язковим в Україні для
        банків, небанківських надавачів платіжних послуг, які відкривають
        платіжні рахунки користувачам, а також для емітентів електронних грошей
        під час формування номеру електронного гаманця.
      </Typography>
      <Typography mb={1}>
        Користувач – це фізична особа, або фізична особа – підприємець, яка
        використовує веб-сайт для здійснення платежу на користь контрагента,
        прийнявши умови цієї публічної оферти.
      </Typography>
      <Typography mb={1}>
        Клієнт – контрагент Користувача, якому надсилається згенероване
        Користувачем посилання на оплату;
      </Typography>
      <Typography mb={1}>
        Мета користування веб-сайтом – використання можливостей, які
        пропонуються на веб-сайті {appLink}, для здійснення платежів третіми
        особами на користь Користувача у сфері торгівлі, громадського
        харчування, надання послуг, виконання робіт тощо.
      </Typography>
      <Typography mb={1}>
        Правовласник – це розробник та власник веб-сайту {appLink}. <br />
        Розробником є Товариство з обмеженою відповідальністю «ФОПкаса»,
        зареєстроване відповідно до чинного законодавства України.
        Місцезнаходження товариства: 79041, Львівська обл., місто Львів, вул.
        Порохова, будинок 20 Д, секція 5.
      </Typography>
      <Typography mb={1}>Сторони – Користувач і Правовласник.</Typography>
      <Typography mb={1}>
        Інші терміни та поняття застосовуються відповідно до положень чинного
        законодавства України
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ВИКОРИСТАННЯ КОРИСТУВАЧЕМ ВЕБ-САЙТУ {appLinkUppercase}
      </Typography>
      <Typography mb={1}>
        Користувач, використовуючи веб-сайт {appLink}, погоджується на вказані
        Умови користування в цілому в редакції на момент здійснення платежу. У
        подальшому Правовласник залишає за собою право оновлювати Умови
        користування в будь-який час без попередження Користувача. Актуальну
        редакцію Умов користування користувач може переглянути, натиснувши
        гіпертекстове посилання &quot;Умови користування&quot;, що розташоване
        на веб-сайті {appLink}. Змінені Правовласником Умови користування
        визнаються і виконуються Користувачем. Якщо Користувач продовжує
        користуватись веб-сайтом після зміни Умов користування, це трактується
        як згода Користувача з новою редакцією Умов користування. У разі незгоди
        Користувача з новою редакцією Умов користування він зобов’язаний
        припинити користування веб-сайтом.
      </Typography>
      <Typography mb={1}>
        Умови користування є договором приєднання. Користувач не може
        пропонувати свої зміни до Умов користування. До відносин Сторін
        застосовуються положення цивільного законодавства України щодо договору
        приєднання.
      </Typography>
      <Typography mb={1}>
        Користувач, який не погоджується з цими Умовами користування, не має
        права користуватися веб-сайтом {appLink}.
      </Typography>
      <Typography mb={1}>Правовласник гарантує:</Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            безперебійну роботу сервісу на веб-сайті {appLink};
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            роботу сервісу на веб-сайті {appLink} без помилок.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        У разі виявлення технічних збоїв у роботі сервісу на веб-сайті {appLink}{" "}
        Правовласник вживає заходів для їх усунення.
      </Typography>
      <Typography mb={1}>
        Користувач не має права змінювати (модифікувати) веб-сайт {appLink}. У
        разі внесення Користувачем змін (модифікацій) до сервісу на веб-сайті{" "}
        {appLink}, Правовласник не несе відповідальності за коректну роботу
        сервісу, а Користувач несе відповідальність за порушення вимог
        законодавства щодо інтелектуальну власність відповідно до вимог закону.
      </Typography>
      <Typography mb={1}>
        Сервіс на веб-сайті {appLink} призначений для використання його
        Користувачем для оптимізації платіжних процесів.
      </Typography>
      <Typography mb={1}>
        Сервіс надає можливість автоматизувати генерацію платіжних посилань за
        допомогою API-інтеграції сервісу веб-сайту {appLink} з CRM та іншими
        бізнес-платформами Користувача.
      </Typography>
      <Typography mb={1}>
        Сервіс на веб-сайті {appLink} для виконання покладених на нього функцій
        вимагає доступу до Інтернету. Обов’язок забезпечити доступ до Інтернету
        під час використання сервісу покладається на Користувача.
      </Typography>
      <Typography mb={1}>Сервіс на веб-сайті {appLink} призначений:</Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            для підприємців, які мають змогу перестати щоразу надсилати
            реквізити в месенджерах і турбуватись про можливі помилки при
            введенні платіжних даних,
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            для клієнтів (фізичних осіб), для яких це зручний спосіб здійснити
            оплату, користуючись своїми банківськими застосунками,
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            для бізнесу, для яких це дає змогу здійснити автоматизацію платіжних
            посилань за допомогою API-інтеграції сервісу з CRM та іншими
            бізнес-платформами.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Сервіс на веб-сайті {appLink} поєднує зручність, безпеку та ефективність
        платіжних операцій.
      </Typography>

      <Typography mb={1}>Сервіс на веб-сайті {appLink}:</Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            забезпечує здійснення оплати без ускладнень (для використання
            сервісу на веб-сайті {appLink} не потрібно реєструвати ПРРО);
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            дозволяє мати рахунок в будь-якому банку (можна використовувати
            банківський рахунок організації чи ФОП, який відкритий в будь-якому
            банку України);
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            дозволяє як безоплатне, так і оплатне використання сервісу залежно
            від тарифів Правовласника;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            дозволяє використовувати згенероване посилання на оплату впродовж
            тривалого часу (час дії посилання необмежений);
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            стабільність посилання на оплату (якщо сума та реквізити залишаються
            актуальними, Користувач може надсилати посилання на оплату
            необмежену кількість разів).
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Порядок роботи сервісу на веб-сайті {appLink}
      </Typography>

      <Typography mb={1}>
        Користувач, використовуючи сервіс на веб-сайті {appLink}, може створити
        особистий кабінет. Для надання повного та якісного обсягу послуг при
        використанні сервісу на веб-сайті {appLink} Користувач може надавати
        Правовласнику (у тому числі під час створення особистого кабінету)
        наступну інформацію:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            прізвище, ім`я, по батькові (за наявності) фізичної особи, адреса
            електронної пошти, номер телефону;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            платіжна інформація Користувача – IBAN, реєстраційний номер
            облікової карти платника податків (використовується для генерації
            платіжного посилання ми також зберігаємо платіжну інформацію
            користувача в базі даних (ІБАН, податковий номер));
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            інша додаткова інформація (зокрема, дані облікового запису
            Користувача в GOOGLE, META тощо), необхідна для використання
            Користувачем сервісу на веб-сайті {appLink};
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            З метою користування розширеними функціями веб-сайту {appLink}{" "}
            Користувач може надавати Правовласнику доступ до свого банківського
            акаунту через токен, який генерується Користувачем в персональному
            кабінеті на сайті банку Користувача (Монобанк, Приватбанк тощо);
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            Персональні дані Користувача збираються, зберігаються та
            використовуються відповідно до Умов конфіденційності, Закону України
            «Про захист персональних даних», Регламенту GDPR.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Користувач для роботи із сервісом на веб-сайті {appLink} з метою
        згенерувати посилання на оплату, повинен ввести наступні реквізити:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>Юридичну назву компанії або ФОП;</Typography>
        </Box>
        <Box component="li">
          <Typography>ЄДРПОУ або РНОКПП;</Typography>
        </Box>
        <Box component="li">
          <Typography>IBAN рахунок;</Typography>
        </Box>
        <Box component="li">
          <Typography>Суму платежу;</Typography>
        </Box>
        <Box component="li">
          <Typography>Призначення платежу.</Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Сервіс на веб-сайті {appLink} може пропонувати Користувачеві і інші
        позиції, які Користувач має змогу ввести.
      </Typography>
      <Typography mb={1}>
        Після створення посилання на оплату Користувач повинен скопіювати його
        та надіслати Клієнту через будь-який месенджер. Клієнт переходить за
        посиланням, натискає «Оплатити», і в банківському додатку Клієнта
        автоматично з’являються всі заповнені реквізити, і залишається лише
        підтвердити платіж.
      </Typography>
      <Typography mb={1}>
        При розрахунку через сервіс на веб-сайті {appLink} чек (фіскалізація) не
        потрібен. У разі потреби приймати готівкові оплати з видачею фіскальних
        чеків потрібно зареєструвати ПРРО, рекомендуємо ПРРО ФОПкаса{" "}
        <Link target="_blank" underline="none" href="https://fopkasa.com/">
          https://fopkasa.com/
        </Link>
        .
      </Typography>
      <Typography mb={1}>
        Для користування сервісом на веб-сайті {appLink} Користувач може
        використовувати будь-який пристрій, який містить банківські застосунки
        (смартфони, tablet тощо). Сервіс на веб-сайті {appLink} автоматично
        працюватиме із застосунками Приватбанк, Монобанк та ще з близько
        двадцятьма додатками інших провідних банків. Сервіс також пропонує
        можливість вставити реквізити вручну у всіх інших випадках.
      </Typography>
      <Typography mb={1}>
        Клієнт може самостійно змінити суму та призначення платежу, зокрема,
        коли клієнт переходить за QR кодом (згенероване посилання), усі дані
        вносяться автоматично, проте є можливість перевірити інформацію та за
        потреби внести зміни вручну перед підтвердженням здійснення оплати.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ОПЛАТА ПОСЛУГ
      </Typography>
      <Typography mb={1}>
        За використання сервісу на веб-сайті {appLink} Користувач сплачує плату
        в розмірі, що встановлений Правовласником на момент створення платежу.
        Правовласник має право безкоштовно надавати всі або частину послуг
        сервісу на веб-сайті {appLink}, проінформувавши про це на веб-сайті{" "}
        {appLink} перед можливістю Користувача здійснити генерацію посилання на
        оплату.
      </Typography>
      <Typography mb={1}>
        Оплата здійснюється Користувачем відповідно до обраного тарифного плану
        (підписка на певний тарифний план), інформація про які міститься на
        веб-сайті {appLink} (зокрема,{" "}
        <Link
          target="_blank"
          underline="none"
          href="https://ibanoplata.com/subscription"
        >
          https://ibanoplata.com/subscription
        </Link>
        ). Тарифний план може бути: базовий, стандарт, преміум або інший,
        визначений Правовласником. Зміст тарифних планів розкрито за посиланням{" "}
        <Link
          target="_blank"
          underline="none"
          href="https://ibanoplata.com/subscription"
        >
          https://ibanoplata.com/subscription
        </Link>
        .
      </Typography>
      <Typography mb={1}>
        Залежно від обраного тарифного плану Користувач отримує змогу вводити
        певну кількість рахунків для прийому IBAN оплат, генерувати визначену
        тарифним планом кількість платіжних посилань, зберігати історію
        платіжних посилань, зберігати шаблони реквізитів оплати, здійснювати API
        інтеграцію, мати персонального консультанта. Обсяг можливостей
        визначається відповідно до обраного тарифного плану.
      </Typography>
      <Typography mb={1}>
        Користувач має право змінювати тарифний план залежно від потреб в
        генерації посилання на оплату. Оплата послуг сервісу, який міститься на
        веб-сайті {appLink} засвідчує погодження Користувача із умовами обраного
        тарифного плану.
      </Typography>
      <Typography mb={1}>
        Користувач у будь-який момент може скасувати підписку (відмовитися від
        обраного тарифного плану) або самостійно в Особистому кабінеті (за його
        наявності), або шляхом надсилання запиту до Служби підтримки за
        контактами, наведеними на сайті {appLink}. При цьому обраний
        Користувачем тарифний план діє до закінчення фактично оплаченого
        Користувачем періоду (місяць, квартал, рік тощо), а сплачені
        Користувачем кошти не повертаються.
      </Typography>
      <Typography variant="h4" mb={1} fontWeight="bold">
        РЕКЛАМА
      </Typography>
      <Typography mb={1}>
        Користувач погоджується, що під час використання сервісу на веб-сайті{" "}
        {appLink} може мати місце показ рекламних оголошень. Види реклами
        визначаються відповідно до закону.
      </Typography>
      <Typography mb={1}>
        Користувач погоджується, що інформація, надана ним під час використання
        сервісу, може використовуватися Правовласником для підбору та подальшої
        демонстрації (показу) Користувачам відповідних рекламних пропозицій.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ВІДПОВІДАЛЬНІСТЬ
      </Typography>
      <Typography mb={1}>
        Користувачі погоджуються з тим, що використовують сервіс на веб-сайті{" "}
        {appLink} добровільно та на власний ризик.
      </Typography>
      <Typography mb={1}>
        Між Правовласником та Користувачами не виникають жодні правовідносини,
        крім тих, які пов’язані з використанням сервісу на веб-сайті {appLink}{" "}
        відповідно до передбачених умовами користування правил.
      </Typography>
      <Typography mb={1}>
        Правовласник не є стороною правовідносин, які виникають між
        Користувачами і клієнтами, між Користувачами і банківськими установами,
        між Користувачами і органами державної фіскальної (податкової) служби
        України, між Користувачами та іншими третіми особами.
      </Typography>
      <Typography mb={1}>
        Правовласник не несе жодної відповідальності за:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            достовірність введення Користувачами даних у сервіс на веб-сайті{" "}
            {appLink};
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            заподіяння шкоди, прямих чи непрямих збитків, штрафів, тощо, які
            може нести Користувач у зв’язку із введенням даних у сервіс на
            веб-сайті {appLink}, або Клієнт, який скористався згенерованим
            Користувачем посиланням на оплату;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            технічні перебої, помилки у роботі сервісу на веб-сайті {appLink} у
            зв’язку із відсутністю підключення до мережі Інтернет у Користувача
            або Клієнта;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            втрати даних та/або іншу заподіяну шкоду, що спричинена іншим
            програмним забезпеченням, яке встановлено Користувачем самостійно на
            пристрій, на якому Користувач використовує сервіс на веб-сайті{" "}
            {appLink}, або за втрати даних та/або іншу заподіяну шкоду, що
            спричинена програмним забезпеченням, яке встановлено Клієнтом на
            його пристрої, на якому Клієнт використовує отримане від Користувача
            посилання;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            втрату даних або грошових коштів Користувача, зумовлену неправильним
            використанням сервісу на веб-сайті {appLink} Користувачем; за втрату
            даних або грошових коштів Клієнта, зумовлену неправильним
            використанням згенерованого Користувачем посилання на оплату;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            штрафи, інші види відповідальності, що застосовуються до Користувача
            у зв’язку із неправильним використанням сервісу на веб-сайті{" "}
            {appLink} самим Користувачем, іншими особами, які відповідно до
            закону та згодою Користувача отримали доступ до сервісу;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            штрафи, інші види відповідальності, що застосовуються до Клієнта у
            зв’язку із неправильним використанням згенерованого Користувачем
            посилання на оплату;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            надання Користувачем або Клієнтом доступу до своїх ідентифікаційних
            даних третім особам та за втрату даних, які цим зумовлені.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Користувачі несуть повну відповідальність відповідно до закону за:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            точність, повноту та достовірність введення даних у сервіс на
            веб-сайті {appLink};
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            дотримання законодавства, в тому числі і податкового, яке підлягає
            застосуванню при використанні Користувачами і Клієнтами сервісу на
            веб-сайті {appLink}.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Користувач зобов’язаний ознайомити з цими Умовами користування інших
        осіб, які відповідно до закону за згодою Користувача використовують
        сервіс на веб-сайті {appLink}. Користувач зобов’язаний навчити таких
        осіб правильно користуватися сервісом. У разі заподіяння шкоди
        Користувачу цими особами внаслідок неправильного використання сервісу на
        веб-сайті {appLink}, Правовласник не відповідає за цю завдану шкоду, в
        тому числі штрафи, інші види відповідальності, застосовані контролюючими
        органами відповідно до закону.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ПОДАТКИ ТА ІНШІ ЗАГАЛЬНООБОВЯЗКОВІ ПЛАТЕЖІ
      </Typography>
      <Typography mb={1}>
        Правовласник та сервіс на веб-сайті {appLink} не виступають податковим
        агентом, посередником чи іншим суб’єктом податкових правовідносин
        Користувача і держави, Клієнта і держави.
      </Typography>
      <Typography mb={1}>
        Виключно Користувачі та Клієнти відповідальні за сплату усіх податків та
        зборів, які підлягають сплаті відповідно до чинного законодавства
        України, а також за правильність ведення податкового обліку.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ПОРЯДОК ВИРІШЕННЯ СПОРІВ
      </Typography>
      <Typography mb={1}>
        Усі спори стосовно використання сервісу на веб-сайті {appLink}{" "}
        вирішуються шляхом проведення переговорів між Сторонами, а у разі
        недосягнення згоди – в судовому порядку.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        ПРАВА ІНТЕЛЕКТУАЛЬНОЇ ВЛАСНОСТІ
      </Typography>
      <Typography mb={1}>
        Виключні майнові права інтелектуальної власності на програмне
        забезпечення, яке використовується на веб-сайті {appLink}, належать
        Правовласнику.
      </Typography>
      <Typography mb={1}>
        Використання сервісу на веб-сайті {appLink} Користувачами здійснюється
        лише в межах, що визначені цими Умовами, та чинним законодавством про
        інтелектуальну власність.
      </Typography>
      <Typography mb={1}>
        Користувачам та іншим особам без згоди Правовласника забороняється
        будь-яким способом (рекламування, модифікація тощо) та у будь-яких цілях
        використовувати сервіс та його назву - «IBAN OPLATA» (крім способів
        використання Користувачами, що зумовлені функціональним призначенням
        сервісу, і які визначені цими Умовами користування). Будь-яке
        відтворення або розповсюдження Користувачами або Клієнтами програмного
        забезпечення, комерційних позначень, що належні Правовласнику,
        заборонено та карається притягненням Користувача, Клієнта або третіх
        осіб до цивільної, кримінальної та іншої, передбаченої законом
        відповідальності.
      </Typography>
      <Typography mb={1}>
        Користувачі визнають та погоджуються, що виключне право на використання
        комерційного позначення (торговельної марки) «IBAN OPLATA» належить
        Правовласнику.
      </Typography>

      <Typography variant="h4" mb={1} fontWeight="bold">
        КОНФІДЕНЦІЙНІСТЬ
      </Typography>
      <Typography mb={8}>
        Відносини Користувача і Правовласника щодо дотримання умов
        конфіденційності врегульовані Умовами конфіденційності, які містяться на
        веб-сайті {appLink}.
      </Typography>
    </WebsiteLayout>
  );
};

export default PrivacyPolicy;
